import React from 'react';
import { Alert, AlertProps } from '@mui/material';

interface Props extends AlertProps {
  type?: 'success' | 'info' | 'warning' | 'error';
  title: string;
}

const Message: React.FC<Props> = ({ type = 'success', title, ...props }) => {
  return (
    <Alert severity={type} {...props}>
      {title}
    </Alert>
  );
};

export default Message;
